<template>
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-2">
      <label class="secondary_color text-sm">Domain (or) Email</label>
      <CustomInput
          v-model="input"
          format="text"
          placeholder="Enter domain or email address"
          :isError="errors.length > 0"
          :errorMessage="errors[0]"
          :auto-focus="true"
          type="primary"
          :disabled="disabled"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import CustomInput from '@/src/components/CustomInput.vue';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['submit', 'success']);

const input = ref('');
const errors = ref([]);

const isValid = computed(() => input.value.length > 0 && errors.value.length === 0);

const validateInput = () => {
  errors.value = [];
  let value = input.value.trim();

  if (!value) {
    errors.value.push('Please enter a domain or email address');
    return false;
  }

  // Remove http://, https://, www., and any additional path or query parameters
  value = value.replace(/^(https?:\/\/)?(www\.)?/, '').split('/')[0];
  // Email validation
  if (value.includes('@')) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      errors.value.push('Please enter a valid email address');
      return false;
    }
  }
  // Domain validation
  else {
    const domainRegex = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    if (!domainRegex.test(value)) {
      errors.value.push('Please enter a valid domain (e.g., example.com)');
      return false;
    }
  }
  // Update input value to cleaned domain or email
  input.value = value;
  return true;
};

const handleSubmit = () => {
  if (validateInput()) {
    emit('submit', input.value.trim());
  }
};

const clearForm = () => {
  input.value = '';
  errors.value = [];
};

defineExpose({
  handleSubmit,
  isValid,
  clearForm,
});
</script>